/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Enabledforallusers3Inputs */

const en_entity_enabledforallusers3 = /** @type {(inputs: Entity_Enabledforallusers3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled For All Users`)
};

const de_entity_enabledforallusers3 = /** @type {(inputs: Entity_Enabledforallusers3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für alle Benutzer aktiviert`)
};

/**
* | output |
* | --- |
* | "Enabled For All Users" |
*
* @param {Entity_Enabledforallusers3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_enabledforallusers3 = /** @type {((inputs?: Entity_Enabledforallusers3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Enabledforallusers3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_enabledforallusers3(inputs)
	return de_entity_enabledforallusers3(inputs)
});
export { entity_enabledforallusers3 as "entity_enabledForAllUsers" }